<template>
  <div class="assgin" v-show="assginShow.assginData">
    <fullVersionTopremium v-if="showpremium" @close="closeTopremium" ></fullVersionTopremium>
    <div class="scroll-container">
      <div class="box">
          <!-- {{assginShow.value.name}} -->
          <header>
              <div class="top">
                   <span>Load Assignment</span>
                    <img @click="close" src="../../../image/drop-down.svg" alt="">
              </div>
              <div class="set-time">
                  <div class="left">
                      <p>
                          <el-checkbox @change="boxSel"></el-checkbox>
                          <span>Set a time frame for the driver to respond</span></p>
                      <p>You will be notified if the driver fails to respond in the time frame.</p>
                  </div>
                  <div class="right">
                      <el-form style="display: flex;" v-if="isSendTime">
                       <el-form-item>
                            <commonInputSelect
                            v-model="hover"
                            :seletData="time"
                            style="width:150px"
                            label="Time"
                            ></commonInputSelect>
                        </el-form-item>
                        <el-form-item>
                            <commonInput
                            :value="`${currentDate} ${currentTime}`"
                            :disabled="true"
                            style="width:180px;margin-left:12px;"
                            ></commonInput>
                        </el-form-item>
                      </el-form>
                  </div>
              </div>
              <assign-tabs :callback="setSelected"/>
          </header>
          <DriverLocation :isAbsolute="false" v-if="isShowDriverPanel" @closeDriverPanel="closeDriverPanel" style="margin-top: 20px"></DriverLocation>
          <main :class="{showSolo: selected === 1, showTeam: selected === 2}">
            <div class="left solo">
              <el-form :model="form" ref="form">
                  <div class="blockDiv">
          
                    <div class="searchWrapper">
                           <svg-icon
                              name="searchIcon"
                              :style="{
                              width: '16px',
                              height: '16px',
                              position: 'absolute',
                              top: '50%',
                              left: '12px',
                              transform: 'translateY(-50%)',
                              }"
                          />

                          <input type="text" :value="keyWord" @input="searchDriver" placeholder="Search Driver Names">
                          <img v-if="keyWord" src="@/assets/img/im-icon/clear.svg" alt="" @click="handleClear" />
                    </div>
                    <common-form style="width: 0px !important" name="FILTERS"
                      :showReset='false'
                      :countOther="roleLength" 
                      :slotNameList="[ 'roleId']">
                    
                      <div prop="Role" style="width: 176px !important; height: 32px !important" slot="roleId" key="roleId">
                        <common-multiple-select-checkbox
                          :order="1"
                          :popperAppendToBodys="true"
                          :clearable="true"
                          @change="applyBySearch"
                          label="Role"
                          v-model="form.roleId"
                          :options="isCommand ? roleFilterList : roleFilterListDispatch">
                        </common-multiple-select-checkbox>
                      </div>
                    </common-form>
              </div>
              </el-form>
              <div class="dirverList" v-loading='driverListLoading' >
                <assign-solo 
                  v-if="!driverListLoading"
                  :currentMilesType="currentMilesType" 
                  :driverSelected="driverSelect" 
                  :filter-data="driverData" 
                  :key-word="keyWord" 
                  :optionsRole="currentRole"
                  @calcClick="calcClick"
                  @calcInput="calcInput"
                />
              </div>
            </div>
            <div class="left team">
                <div class="manage">
                    <div class="searchWrapper">

                          <svg-icon
                              name="searchIcon"
                              :style="{
                              width: '16px',
                              height: '16px',
                              position: 'absolute',
                              top: '50%',
                              left: '12px',
                              transform: 'translateY(-50%)',
                              }"
                          />
                          <input type="text"  :value="teamKeyWord" @input="searchTeamDriver" placeholder="Search Driver Names" />
                          <img v-if="teamKeyWord" src="@/assets/img/im-icon/clear.svg" alt="" @click="handleTeamClear" />
                    </div>
                    <img class="manageImg" src="@/assets/img/driver/manage.svg" @click="goManage" alt="">
                </div>
                <assign-team :team-key-word="teamKeyWord" :selected-call-back="teamSelect"/>
              </div>
              <div ref="assignMap" class="assignMapBox"></div>
          </main>
          <footer>
              <div class="control">
                <div>
                  <selectEmptyMilesVue  v-if="!driverListLoading" @optionClicked="optionClicked"></selectEmptyMilesVue>
                </div>
                <div>
                  <common-button style="height: 32px !important; border: 1px solid #B4BAC8; color: #4C556C;" type="text" @click="cancel" >CANCEL</common-button>
                  <common-button
                      type="primary"
                      style="height: 32px !important"
                      @click="assgin"
                      :disabled="!(currentId !== undefined && successAssign === true)"
                      :loading="loading"
                      >ASSIGN
                  </common-button>
                </div>
              </div>
          </footer>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment-timezone";
  import appendToDom from "@/components-v3/mixins/append-to-dom"
import fullVersionTopremium from '@/views/login-v2/full-version-to-premium-dialog/index.vue'
import { mapState, mapActions, mapGetters } from 'vuex'
import { getDistance } from "@/routing/api";
import { convertMetersToMiles } from '@/filters'
import { getRoute, isHasRoute } from '@/utils/add-route/catch-api'
import {
  re_assign, assign, getTripIdInfo,
  saveFilter as saveFilterApi,
  getFilter as getFilterApi,
  // saveFilterDSP as saveFilterApiDSP,
  // getFilterDSP as getFilterApiDSP
} from '../../api/new-index.js'
import DriverLocation from '@/views/dispatchs/dispatch/components/driver-location-tips'
import AssignTabs from "./assign-tabs"
import AssignTeam from "./assign-team";
import AssignSolo from "./assign-solo";
import { getDriverList, calcLoadEmptyMiles } from '@/views/dispatchs/dispatch/api/new-index'
// import MarkerController from '../../detail/components/tracking/tools/_marker'
import { assignToTeam } from "@/api/driver";
import {DispatchComponents$} from '@/shared-services'
import { Subject } from 'rxjs'

import {systemInfo} from "@/shared-services";
import selectEmptyMilesVue from './select-empty-miles.vue';
// let refreshMark = 0

const requestType = {
  0: 'CURRENT',
  1: 'LAST_DROP_OFF',
  2: 'EDIT'
}

export default {
    name:'assgin',
    components: {AssignTeam, AssignTabs, AssignSolo, fullVersionTopremium, DriverLocation, selectEmptyMilesVue},
    mixins: [appendToDom()],
    data() {
        return {
            selected: 1,
            currentId: undefined,
            currentTeam: undefined,
            currentDriver: undefined,
            currentRole: [],
            arr: [],
          roleFilterList: [{
            label: 'Admin',
            value: 0,
          }, {
            label: 'Operator',
            value: 2,
          }, {
            label: 'Driver',
            value: 1,
          }],
          roleFilterListDispatch: [{
            label: 'Admin',
            value: 0,
          }, {
            label: 'Driver',
            value: 1,
          }],
            isDisabled: true,
            loading: false,
            keyWord: '',
            teamKeyWord: '',
            numberSize: 24,
            time: [],
            hover: '',
            driverNames: undefined,
            currentTime: undefined,
            currentDate: undefined,
            isSendTime: false,
            currentInfo: undefined,
            mapLoading: false,
            successAssign: false,
            stopPoit: [],
            driverListLoading: false,
            driverData: [],
            detailData: '',
            driverDistancePickup: '',
            mapRoute: [],
            currentDriverInfo: null,
            showpremium: false,
            isShowDriverPanel: false,
            tripInfo: null,
            cacheLoadInfo: null,
            waypointList: [],
            roleLength: 0,
            currentMilesType: 1,
          form: {
            search: '',
            roleId: [],
          },
          assignSubject: new Subject(),
          isCommand: systemInfo.isCommand ? true : false,
          cacheDriverData: []
        }
    },
      watch: {
        numberSize: {
            handler(value) {
                for(let i=1; i<=value; i++) {
                    if(i%2 === 0) {
                        this.time.push({value: i,label: i+' Hours'})
                    }
                }
            },
            immediate: true
        },
        keyWord(news) {
          this.fuzzyQuery(news, this.currentRole)
        },
        currentRole(news) {
          console.log(news,'currentRole');
          this.fuzzyQuery(this.keyWord, news)
        },
        hover: {
            handler(value) {
                if(value == '2 Hours') return;
                let curTime = new Date();
                let addHour = curTime.setHours(curTime.getHours() + value)
                this.currentDate = moment(addHour).format('MM/DD/YYYY');
                this.currentTime = moment(addHour).format('HH:mm A'); 
            },
            deep: true
        },
        assginShow:{
            handler(data) {
              console.log(data,'168result');
                this.cacheLoadInfo = data.value && data.value.loadInfo
                if(data.assginData) {
                    let loadInfo = data.value.loadInfo
                    this.driverListLoading = true
                    this.currentMilesType = 1
                    getDriverList(this.isCommand, data.value.loadInfo.id).then(( res ) => {
                            this.driverListLoading = false
                            let data = res.data.data
                            this.driverData = data.map(item => {
                                return {
                                    ...item,
                                    distance: '',
                                }
                            }).filter(x => x.workStatus !== 'inactive');
                            this.cacheDriverData = this.driverData
                            data.forEach(item => {
                                if(item.latitude && item.longitude) {
                                    const params = {
                                        origin: `${item.latitude},${item.longitude}`,
                                        destination: `${loadInfo.pickupLat},${loadInfo.pickupLon}`,
                                    }
                                    let id = item.driverId
                                    let getData =  getDistance(params).then(( {res} ) => {
                                        return {
                                            res: res,
                                            driverId: id
                                        }
                                    })
                                    Promise.race([getData]).then(( res ) => {
                                        try {
                                            let sections = res.res.data.routes[0]?.sections
                                            let distance = sections?.reduce((total, item) => total + item.summary.length, 0)
                                            let currentDriverIdIndex = this.driverData.findIndex(x => x.driverId === res.driverId)
                                            this.$set(this.driverData[currentDriverIdIndex], 'distance', convertMetersToMiles(distance, 2))
                                        } catch(error) {
                                            console.log(error)
                                        }
                                    })
                                }
                            })
                    })
                  this.$nextTick(() => {
                    DispatchComponents$.subscribe(x => x.loadAssignMap(
                      this.$refs.assignMap,
                      this.mapLoading,
                      this.waypointList,
                      this.mapRoute,
                      this.currentDriverInfo,
                      this.assignSubject
                    ))
                  })
                }
                if(data.value) {
                    this.mapLoading = true
                    this.successAssign = false
                    this.mapRoute = []
                    isHasRoute(data.value.id).then(( res ) => {
                        if(res) {
                            this.successAssign = true
                        }
                    }).catch(( error ) => {
                        this.successAssign = false
                        this.$message.error(error)
                    })
                    getRoute(data.value.id).then(( res ) => {
                        this.mapLoading = false
                        this.successAssign = true
                        this.mapRoute = res.route
                        this.waypointList = res.waypoint
                    }).catch(( error ) => {
                        this.mapLoading = false
                        // this.successAssign = false
                        this.$message.error(error)
                    })
                }
            },
            deep: true,
            immediate: true
        },

        mapLoading(value) {
          this.assignSubject.next({ key: 'loading', value  })
        },
        mapRoute(value) {
          this.assignSubject.next({ key: 'routeData', value  })
        },
        waypointList(value) {
          this.assignSubject.next({ key: 'waypointList', value  })
        },
        currentMilesType(value, oldValue) {
          console.log(oldValue,'oldValue', [0,1].includes(oldValue) && [2].includes(value));
          const type = requestType[value]
          if(oldValue === 2 && [0,1].includes(value)) {
             this.driverData = this.driverData.map((item) => {
                return {
                  ...item,
                  emptyMils: null,
                  eidtCalc: null
                }
            })
          }

          if(oldValue === 0 && [1].includes(value)) {
              const driverIdList = this.driverData.map((item, index) => {
                if(item.emptyMils) {
                  return {
                    id: item.driverId,
                    index: index
                  }
                }
              }).filter(item => item)
              driverIdList.forEach(item => {
                const parmas = {
                  driverId: item.id,
                  type: type,
                  loadId: this.assginShow.value.id,
                  eidtCalc: null
                }
                this.calcEmilesApiFns(parmas, item.index)
              })
             this.driverData = this.driverData.map((item) => {
                return {
                  ...item,
                  emptyMils: item.emptyMils || null,
                  eidtCalc: null
                }
              })
          }

          if(oldValue === 1 && [0].includes(value)) {
              const driverIdList = this.driverData.map((item, index) => {
                if(item.emptyMils) {
                  return {
                    id: item.driverId,
                    index: index
                  }
                }
              }).filter(item => item)
              driverIdList.forEach(item => {
                const parmas = {
                  driverId: item.id,
                  type: type,
                  loadId: this.assginShow.value.id,
                  eidtCalc: null
                }
                this.calcEmilesApiFns(parmas, item.index)
              })
             this.driverData = this.driverData.map((item) => {
                return {
                  ...item,
                  emptyMils: item.emptyMils || null,
                  eidtCalc: null
                }
            })
          }
          if([0,1].includes(oldValue) && [2].includes(value)) {
              this.driverData = this.driverData.map((item) => {
                return {
                  ...item,
                  emptyMils: item.emptyMils || '0',
                  eidtCalc: 'EDIT'
                }
              })
          }
        },
        currentDriverInfo(value) {
          if (value.latitude && value.longitude) {
            this.assignSubject.next({ key: 'driverInfo', value: { ...value, avatarImg: value.userImage }  })
          } else {
            this.$message.warning("The driver hasn't shared their location from the Trucker Path app yet.")
          }
        },
    },
    created() {
        this.hover = '2 Hours'
        this.currentDate = moment(Date.now()).format('MM/DD/YYYY');
        this.currentTime = moment(Date.now()).format('HH:mm A'); 
    },
    mounted() {
      // this.driverGPSService.watchList(this.getDriverByWatch)
      // const getFilterData = systemInfo.isCommand ? () => getFilterApi() : () => getFilterApiDSP();
      getFilterApi().then(res => {
        console.log(res.data,'res.data')
        if (res.data.length) {
          res.data.forEach(item => {
            if(!isNaN(item)) {
              this.currentRole = res.data
              this.form['roleId']= res.data
              this.roleLength = res.data.length
            }
            if(item['DRIVER']) {
              localStorage.setItem('DRIVER', JSON.stringify(item['DRIVER']))
              this.currentRole = item['DRIVER']
              this.form['roleId']= item['DRIVER']
              this.roleLength = item['DRIVER'].length
            }
          })
        }
      }).catch((err) => {
        console.log('defaultRole:::316 err ', err)
      })
    },
    methods: {
        ...mapActions("im", ["showChatbox"]),
        ...mapActions({
            showAssgin: 'dispatch/showAssgin',
            getTaskListAsync: 'dispatch/getTaskList',
            setDistance: 'dispatch/setDistance',
            sendCustomMsg: "im/sendCustomMsg",
        }),
        fuzzyQuery(keyWord,optionsRole = []) {
          if(!keyWord && (optionsRole && optionsRole.length == 0)) {
           this.driverData = this.cacheDriverData
           return
          }
          const search = keyWord
          const option = optionsRole
          let tempArray 
          const list = this.driverData ? this.driverData : this.cacheDriverData
          if (search) {
            tempArray = list.filter(item => {
              if (search) {
                console.log(item.driverName, search, '116');
                const formattedSearch = search.toLowerCase().replace(/\s/g, "");
                const formattedDriverName = item.driverName.toLowerCase().replace(/\s/g, "");
                return formattedDriverName.includes(formattedSearch)
              }
            })
          }
          if (option&&option.length) {
            tempArray = list.filter(item => {
              if (option) {
                console.log(item.driverName, search, '116');
                return option.includes(item.role)
              }
            })
          }
          this.driverData = tempArray
        },
        calcClick(item, index) {
          if(requestType[this.currentMilesType] == 'EDIT') {
            this.driverData[index]['eidtCalc'] = 'EDIT'
          }else {
            const parmas = {
              driverId: item.driverId,
              type: requestType[this.currentMilesType],
              loadId: this.assginShow.value.id
            }
            console.log(parmas,'parmas');
            this.calcEmilesApiFns(parmas, index)
            // this.driverData[index]['calcLoading'] = true
          }
        },
        calcInput(item, index) {
          console.log(item, 'calcInput');
          this.driverData[index]['emptyMils'] = item || '0'
        },
        calcEmilesApiFns(parmas, index) {
          this.$set(this.driverData[index], 'calcLoading', true)
          console.log(this.driverData,'this.driverData-test');
          calcLoadEmptyMiles(parmas).then(( res ) => {
            console.log(res,'parmasres');
            this.$set(this.driverData[index], 'calcLoading', false)
            this.$set(this.driverData[index], 'emptyMils', res.data.emptyMils || '0')
          })
          .catch(( ) => {
            this.$set(this.driverData[index], 'calcLoading', false)
          })
        },
        optionClicked(type) {
          this.currentMilesType = type
        },
        cancel() {
            this.close()
        },
        applyBySearch(option){
          this.roleLength=option&&option.length
          this.currentRole= option || []
        },
        // resetAll() {
        //   this.keyWord = ''
        //   this.teamKeyWord = ''
        //   this.currentRole=undefined
        // },
        closeDriverPanel() {
          this.isShowDriverPanel = false
        }, 
        setSelected(index) {
          this.selected = index;
          this.selected === 1 ? this.driverSelect(this.currentDriver) : this.teamSelect(this.currentTeam)
        },
        goManage() {
          this.close()
          this.$router.push({
            path: '/driver/index?tab=4'
          })
        },
        teamSelect(item) {
          if(!item) {
            this.checkoutDriver()
            return;
          }
          this.currentTeam = item;
          this.pushToAppIdList = [item.primaryDriverId, item.secondlyDriverId]
          console.log(this.currentTeam,'zzzzz');
          const primaryDriver = this.driverData.filter(x => item.primaryDriverId === x.driverId)[0]
          if(!primaryDriver) {
            return
          }
          this.checkoutDriver(primaryDriver)
        },
        driverSelect(item) {
          this.pushToAppIdList = item && item.driverId ? [item.driverId] : []
          this.currentDriver = item;
          this.checkoutDriver(item)
        },
        closeTopremium() {
          this.showpremium = false
          this.showAssgin({
              assginData: false,
          })
        },
        checkoutDriver(item) {
          console.log(item,'279result');
          if(item) {
            this.isShowDriverPanel = item && item.switchStatus ? false : true
            const driverId = item && item.driverId
            this.currentDriverInfo = item
            this.$nextTick(() => {
                this.$forceUpdate()
                this.$set(this, 'currentId', driverId)
            })
            this.isDisabled = false;
            this.driverNames = item.driverName;
            if(this.detailData && item.latitude !== null && item.longitude !== null) {
                const params = {
                    origin: `${item.latitude},${item.longitude}`,
                    destination: `${this.detailData.loadInfo.pickupLat},${this.detailData.loadInfo.pickupLon}`,
                }
                    this.searchDriver("")
                
                let data = getDistance(params).then(( {res} ) => {
                    return  {
                        data: res,
                        id: driverId
                    }
                })
                
                Promise.race([data]).then(( res ) => {
                    console.log(res,'276');
                })

            }else {
                this.$set(this, 'currentId', '')
            }
          }
            
        },
        //搜索
        searchDriver(value) {
          this.keyWord = value ? value.target.value : '';
        },
        searchTeamDriver(value) {
          this.teamKeyWord = value.target.value;
        },
        boxSel() {
            this.isSendTime = !this.isSendTime
        },
        close() {
            this.showAssgin({
                assginData: false,
            })
            this.$emit('closeAssignDiaLog')
        },
 handleClear() {
        this.keyWord = '';
      }, 
      handleTeamClear() {
        this.teamKeyWord = '';
      },

        formatPushTripAppParams(data) {
          const keysTrip = Object.keys(data)
            getTripIdInfo(this.cacheLoadInfo.id).then(( res ) => {
              console.log(this.pushToAppIdList,'this.pushToAppIdList');
              const routeData = JSON.parse(res.data)
              const wayPointData = routeData.sendRoute
              wayPointData.distance  = Number(routeData.sendRoute.distance)
              if(keysTrip.length && keysTrip.length === 1) {
                this.assignTripFnc(keysTrip[0], wayPointData, routeData, data[keysTrip[0]])
              }else {
                keysTrip.forEach((item) => {
                  this.assignTripFnc(item, wayPointData, routeData, data[item]) 
                })
              } 
            })
        },
        assignTripFnc(id, wayPointData, routeData, tripId) {
          const tripInfoDriver = this.driverData.filter(item => item.tpUserId == id)[0]
          const userParmas = {
            ...tripInfoDriver,
            id: tripInfoDriver.driverId,
            role: this.UserRole,
            tpUserId: id,
            sendText: true,
            addId: routeData.webId,
            AppId: routeData.id,
            sendSmsNotificationChecked: true
          }
          let flag = this.singleList.find((item) => {
            return item.tpUserId == userParmas.tpUserId;
          });
          console.log(routeData,'505jieguo', flag)
          if (flag) {
              userParmas.to = flag.accId
              this.showChatbox({
                show: true,
                account: flag ? flag.accId : "fleet_1191",
                top: 30,
              });
          } 
          console.log(tripId,'tripId');
          this.sendCustomMsg({options: userParmas, sendData: wayPointData, tripId: tripId, loadId: routeData.loadId })
        },
        assgin() {
            this.$buriedPoints(7.5);  
            this.loading = true
            const loadId = this.assginShow.value.id;
            const emptyMils = this.currentDriver ? this.driverData.filter(item => item.driverId === this.currentDriver.driverId)[0].emptyMils : null
            if(this.assginShow.value.name === 'Assign') {
                var time = undefined;
                if(this.isSendTime) {
                    time = this.hover === '2 Hours' ? 2 : this.hover
                }else {
                    time = 0
                }
                //buried event for team driver assigned load
                if(this.selected === 2){
                    this.$buriedPoints(16.0);
                }
                const loadList = localStorage.getItem('LOADLIST') ? JSON.parse(localStorage.getItem('LOADLIST')) : []
                // const saveFilterData= systemInfo.isCommand ? ()=>saveFilterApi(this.currentRole) :()=> saveFilterApiDSP(this.currentRole);
                const assignFunc = this.selected === 1 ?
                    () => assign(this.currentDriver.driverId,[loadId], time, emptyMils) :
                    () => assignToTeam(this.currentTeam.teamId, [loadId], false);
                assignFunc()
                .then(( res ) => {
                  console.log(res,'540');
                  if (res.code === 200) {
                     if(this.selected===1){
                      saveFilterApi([{DRIVER: this.currentRole||[], LOADLIST: loadList}]).then(()=>{
                        localStorage.setItem('DRIVER', JSON.stringify(this.currentRole||[]))
                    }).catch((err)=>{
                      this.$message.error(err.message)
                    })}
                    this.loading = false;
                    this.$message.success(`Load successfully assigned.`)
                    this.showAssgin({
                      assginData: false,
                    })
                    this.formatPushTripAppParams(res.data)
                    this.$emit('success')
                  }
                })
                .catch((error) => {
                    if (error) {
                        this.loading = false
                        if(error.code === 508) {
                          this.showpremium = true
                          return
                        }
                        this.$message.error(error.message)
                      }
                })
            }else {
//  const saveFilterData= systemInfo.isCommand ? ()=>saveFilterApi(this.currentRole) :()=> saveFilterApiDSP(this.currentRole);
              const loadList = localStorage.getItem('LOADLIST') ? JSON.parse(localStorage.getItem('LOADLIST')) : []
              const reAssignFunc = this.selected === 1 ?
                  () => re_assign(this.currentDriver.driverId, [loadId], emptyMils) :
                  () => assignToTeam(this.currentTeam.teamId, [loadId], true);
              reAssignFunc()
                  .then((res) => {
                    if (res.code === 200) {
                   if(this.selected===1){saveFilterApi([{DRIVER: this.currentRole||[], LOADLIST: loadList}]).then((res)=>{
                      console.log('472:::',res)
                    }).catch((err)=>{
                      console.log('472:::',err)

                      this.$message.error('Filter Not Saved')
                    })}
                      this.loading = false;
                      this.formatPushTripAppParams(res.data)
                      this.showAssgin({
                        assginData: false,
                      })
                      this.$emit('success')
                    }
                  }).catch((error) => {
                    if (error) {
                      this.loading = false
                      if(error.code === 508) {
                        this.showpremium = true
                        return
                      }
                      this.$message.error(error.message)
                    }
              })
            }
            
            
        },
        
    },
    computed: {
        ...mapState({
            // driverData: (state) => state.dispatch.driverData,
            assginShow: (state) => state.dispatch.assginShow,
            assignData: (state) => state.dispatch.assign,
            loadDetailList: (state) => state.dispatch.loadDatailList,
            friends: (state) => state.im.friends,
            singleList: (state) => state.im.singleList,
            
        }),
        ...mapGetters({
          UserRole: "user/role",
        }),
    },
    beforeDestroy() {
      DispatchComponents$.subscribe(x => x.loadAssignMap(null))
    }
}
</script>

<style lang="scss" scoped>
.assgin {
   top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    z-index: 2001;
    display: flex;
    position: fixed;
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.65);
    overflow: scroll;
    .scroll-container {
      height: 100%;
      max-height: 728px;
      overflow: scroll;
    }
    .box {
        width: 800px;
        border-radius: 8px;
        background: #fff;
        header {
            border-bottom: 1px solid #dadce1;
            height: 164px;
            overflow: hidden;
            padding: 24px 0 0;
            .top {
                 display: flex;
                 height: 25px;
                 padding: 0 23px;
                 align-items: center;
                 justify-content: space-between;
                 margin-bottom: 16px;
                 span {
                    font-size: 18px;
                    font-weight: 700;
                }
                img {
                    cursor: pointer;
                }
            }
            .set-time {
                display: flex;
                padding: 0 23px;
                p:nth-child(1) {
                    display: flex;
                    align-items: center;
                    span {
                        margin-left: 8px;
                        font-weight: 600;
                        font-weight: 500;
                        font-size: 14px;
                    }
                }
                p:nth-child(2) {
                    margin-left: 21px;
                    font-family: OpenSans;
                    font-weight: 600;
                    font-size: 12px;
                    color: #7f8596;
                    margin-top: 4px;
                }
                /deep/ {
                    .el-input__inner {
                        padding: 4px 12px 0 !important;
                    }
                }
                
            }
          .left {
            flex: 1;
          }
          .right {
            ::v-deep {
              .el-form-item {
                margin-bottom: 0;
              }
            }
          };
        }
        main {
            flex: 1;
            height: 412px;
            display: flex;
            padding: 16px 23px 15px;

          justify-content: space-between;
            &.showSolo {
              .solo {
                display: block;
              }
            }
            &.showTeam {
              .team {
                display: block;
              }
            }
            .left {
              width: 460px;
              height: 100%;
              padding-right: 10px;
              display: none;
              &.team {
                .manage {
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                padding: 0px;
                gap: 12px;

                width: 362px;
                height: 32px;
                  .searchWrapper {
                    position: relative;
                    // padding-left: 24px;
                    img {
                      display: none;
                      position: absolute;
                      top: 50%;
                      right: 16px;
                      transform: translateY(-50%);
                      cursor: pointer;
                    }

                    &:hover img {
                      display: block;
                    }
                  }
                  input {
                    width: 259px;
                  }
                  .manageImg{
                    cursor: pointer;
                    height: 22px;
                  }
                }
              }
              input {
                width: 259px;
                height: 32px;
                outline: none;
                font-weight: 500;
                padding-left: 30px;
                border-radius: 20px;
                color: #b2b6c0;
                border: solid 1px #dadce1;
              }
              ::-webkit-input-placeholder {
                font-weight: 500;
                font-size: 14px;
                font-weight: 500;
                font-stretch: normal;
                font-style: normal;
                line-height: normal;
                letter-spacing: normal;
                color: #b2b6c0;
                position: absolute;
                top: 18%;
                left: 30px;
              }
              .dirverList {
                  height: calc(100% - 40px);
                  overflow: hidden;
                  overflow-y: auto;
                  margin-top: 10px;
                  dl {
                      width: 100%;
                      padding: 15px;
                      height: 123px;
                      border-radius: 4px;
                      cursor: pointer;
                    //   margin-top: 2px;
                    //   border: 1px solid #f0f2f5;
                    //   border-top: hidden;
                    //   border-left: hidden;
                    //   border-right: hidden;
                      border-bottom: 1px solid #f0f2f5;
                      dt {
                          display: flex;
                          align-items: center;
                          .name {
                            //   margin-left: 9px;
                              font-weight: 500;
                              font-size: 14px;
                          }
                      }
                      dd {
                         margin-top: 12px;
                         margin-left: 33px;
                         .title {
                             font-family: OpenSans;
                             font-size: 12px;
                             color: #7f8596;
                         }
                         .son {
                             font-weight: 500;
                             font-size: 12px;
                             color: #000000;
                         }
                      }
                  }
                  dl:hover {
                      background: #f6f7f9;
                  }
              }
            .blockDiv{
                display: flex;
                flex-direction: row;
                align-items: center;
        

        .searchWrapper {
              position: relative;
              // padding-left: 24px;

              img {
                display: none;
                position: absolute;
                top: 50%;
                right: 16px;
                transform: translateY(-50%);
                cursor: pointer;
              }

              &:hover img {
                display: block;
              }
            }
            }
            }
            .assignMapBox {
              width: 450px;
              border: 1px solid #DADCE1;
              border-radius: 4px;
              overflow: hidden;
              ::v-deep {
                .baseMapContainer {
                  border-radius: 4px;
                }
              }
            }
            
        }
        footer {
            width: 100%;
            height: 72px;
            border-radius: 8px;
            .control {
                display: flex;
                height: 72px;
                align-items: center;
                line-height: 80px;
                 border-top: 1px solid #dadce1;
                justify-content: space-between;
                cursor: pointer;
                padding: 0 24px;
                span {
                    color:#4C556C;
                    font-weight: 500;
                    font-size: 14px;
                    //    float: right;
                }
                span:hover {
                    color: #000;
                }
                .confirmBtn {
                    outline: none;
                    border: none;
                    margin-left: 24px;
                    width: 75px;
                    font-size: 14px;
                    height: 32px;
                    border-radius: 2px;
                    margin-right: 23px;
                    color: #fff;
                    cursor: pointer;
                    font-weight: 500;
                    // line-height: 32px;
                    display: flex;
                    justify-content: center;
                    background: #DADCE1;
                    /deep/ span {
                        line-height: 8px;
                        display: inline-block;
                    }
                    /deep/ i {
                        line-height: 10px;
                    }
                }
            }
        }
    }
}
.map-container {
  width: 310px;
  height: 100%;
}
/deep/ .el-checkbox__inner {
    border: 1px solid #b2b6c0;
}
/deep/ .el-checkbox__input.is-checked .el-checkbox__inner {
    border-color: #4066d4;
    background-color: #4066d4;
}
/deep/ .driverGps {
   width: 32px; height:32px; background: #01a2b5; border-radius: 50px;position: relative; display: flex; align-items: center;    left: -10px;
   .driverName {
        width: 26px;
        height: 26px;
        border-radius: 50%;
        background: #ffff;
        margin: 0 auto;
        line-height: 26px;
        text-align: center;
   }
    img { 
        width: 26px;
        height: 26px;
        border-radius: 50%;
        margin: 0 auto;
        border: 2px solid #fff;
    }
}
.searchWrapper {
  position: relative;
  // padding-left: 24px;

  img {
    display: none;
    position: absolute;
    top: 50%;
    right: 16px;
    transform: translateY(-50%);
    cursor: pointer;
  }

  &:hover img {
    display: block;
  }
}

/deep/ .avatar {
      margin-right: 12px;
      position: relative;

      > span {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        color: #FFF;
      }
}
</style>
